var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _path2, _rect8, _rect9, _path3, _ellipse, _path4, _circle, _ellipse2, _path5, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect10, _rect11, _path14, _rect12, _rect13, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 261,
    viewBox: "0 0 375 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.5099,
    y: 149.296,
    width: 61.058,
    height: 110.704,
    fill: "#F7F7F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.5829,
    y: 110.91,
    width: 26.9849,
    height: 59.9692,
    fill: "#F7F7F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 85.4507,
    y: 105.784,
    width: 45.3492,
    height: 154.216,
    fill: "#F7F7F7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 281.152,
    y: 87.7927,
    width: 44.0324,
    height: 172.207,
    fill: "#F7F7F7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 167,
    width: 90,
    height: 93,
    fill: "#F7F7F7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 111.614,
    y: 193.99,
    width: 54.0801,
    height: 66.0096,
    fill: "#F7F7F7"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 138.654,
    y: 62.1211,
    width: 109.004,
    height: 197.112,
    rx: 6,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.989 73.4931C142.989 70.1793 145.676 67.4931 148.989 67.4931H168.073C171.318 67.4931 170.627 71.734 174.344 71.9197H180.615H193.157H205.698H211.969C215.279 71.9197 214.856 67.4931 218.24 67.4931H237.324C240.637 67.4931 243.324 70.1793 243.324 73.4931V247.861C243.324 251.175 240.637 253.861 237.324 253.861H148.989C145.676 253.861 142.989 251.175 142.989 247.861V73.4931Z",
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.306 77.218C145.306 73.9043 147.992 71.218 151.306 71.218H169.594C172.736 71.218 172.067 75.3584 175.666 75.5396H181.738H193.882H206.027H212.099C215.304 75.5396 214.894 71.218 218.171 71.218H236.459C239.773 71.218 242.459 73.9043 242.459 77.218V247.166C242.459 250.48 239.773 253.166 236.459 253.166H151.306C147.992 253.166 145.306 250.48 145.306 247.166V77.218Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 247.659,
    y: 88.4083,
    width: 2.38652,
    height: 10.6709,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 247.659,
    y: 110.91,
    width: 2.38652,
    height: 23.8064,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M235.442 247.844C203.651 243.926 173.444 233.655 170.644 216.011C167.844 198.366 180.017 188.931 197.164 185.756C220.695 181.398 228.492 168.789 220.2 151.876C210.74 132.583 178.008 133.047 178.008 133.047",
    stroke: "#828282",
    strokeWidth: 5,
    strokeLinejoin: "round",
    strokeDasharray: "12 12"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.243,
    cy: 134.139,
    rx: 4.29944,
    ry: 0.578346,
    fill: "#828282"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.97 115.512C179.97 120.884 170.243 132.276 170.243 132.276C170.243 132.276 160.515 120.884 160.515 115.512C160.515 110.139 164.871 105.784 170.243 105.784C175.615 105.784 179.97 110.139 179.97 115.512Z",
    fill: "white",
    stroke: "#4A4A4A",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 170.243,
    cy: 115.512,
    r: 5.54634,
    fill: "#B0B0B0"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.151,
    cy: 133.402,
    rx: 19.421,
    ry: 5.19175,
    fill: "white",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M282.264 86.6769C282.264 101.651 255.151 133.403 255.151 133.403C255.151 133.403 228.039 101.651 228.039 86.6769C228.039 71.7031 240.177 59.5644 255.151 59.5644C270.125 59.5644 282.264 71.7031 282.264 86.6769Z",
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 255.151,
    cy: 86.6767,
    r: 15.4588,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.4464,
    cy: 248.088,
    r: 10.76,
    fill: "#B0B0B0"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.56,
    cy: 248.088,
    r: 10.76,
    fill: "#B0B0B0"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.0493,
    cy: 247.126,
    r: 8.51836,
    fill: "#E0E0E0"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 140.692,
    cy: 247.126,
    r: 8.51836,
    fill: "#E0E0E0"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.4464,
    cy: 248.088,
    r: 9.76004,
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 141.56,
    cy: 248.088,
    r: 9.76004,
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.145 182.631V247.64H155.003C154.766 240.419 148.838 234.638 141.56 234.638C134.282 234.638 128.354 240.419 128.117 247.64H77.8893C77.6527 240.419 71.7247 234.638 64.4465 234.638C57.1683 234.638 51.2403 240.419 51.0038 247.64H35.3046V229.706L55.928 199.22H80.1381V182.631H170.145Z",
    fill: "#BDBDBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.145 247.64V248.64C170.698 248.64 171.145 248.192 171.145 247.64H170.145ZM170.145 182.631H171.145C171.145 182.079 170.698 181.631 170.145 181.631V182.631ZM155.003 247.64L154.003 247.672C154.021 248.212 154.463 248.64 155.003 248.64V247.64ZM128.117 247.64V248.64C128.657 248.64 129.099 248.212 129.117 247.672L128.117 247.64ZM77.8893 247.64L76.8898 247.672C76.9075 248.212 77.3497 248.64 77.8893 248.64V247.64ZM51.0038 247.64V248.64C51.5434 248.64 51.9856 248.212 52.0033 247.672L51.0038 247.64ZM35.3046 247.64H34.3046C34.3046 248.192 34.7523 248.64 35.3046 248.64V247.64ZM35.3046 229.706L34.4763 229.146C34.3644 229.311 34.3046 229.507 34.3046 229.706H35.3046ZM55.928 199.22V198.22C55.5961 198.22 55.2857 198.384 55.0997 198.659L55.928 199.22ZM80.1381 199.22V200.22C80.6904 200.22 81.1381 199.772 81.1381 199.22H80.1381ZM80.1381 182.631V181.631C79.5858 181.631 79.1381 182.079 79.1381 182.631H80.1381ZM171.145 247.64V182.631H169.145V247.64H171.145ZM155.003 248.64H170.145V246.64H155.003V248.64ZM141.56 235.638C148.297 235.638 153.784 240.989 154.003 247.672L156.002 247.607C155.748 239.849 149.38 233.638 141.56 233.638V235.638ZM129.117 247.672C129.336 240.989 134.823 235.638 141.56 235.638V233.638C133.741 233.638 127.372 239.849 127.118 247.607L129.117 247.672ZM77.8893 248.64H128.117V246.64H77.8893V248.64ZM64.4465 235.638C71.1834 235.638 76.6709 240.989 76.8898 247.672L78.8887 247.607C78.6346 239.849 72.2661 233.638 64.4465 233.638V235.638ZM52.0033 247.672C52.2222 240.989 57.7096 235.638 64.4465 235.638V233.638C56.627 233.638 50.2585 239.849 50.0044 247.607L52.0033 247.672ZM35.3046 248.64H51.0038V246.64H35.3046V248.64ZM34.3046 229.706V247.64H36.3046V229.706H34.3046ZM55.0997 198.659L34.4763 229.146L36.1329 230.267L56.7563 199.78L55.0997 198.659ZM80.1381 198.22H55.928V200.22H80.1381V198.22ZM79.1381 182.631V199.22H81.1381V182.631H79.1381ZM170.145 181.631H80.1381V183.631H170.145V181.631Z",
    fill: "#4F4F4F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.08 182.631V247.64H155.003C154.766 240.419 148.838 234.638 141.56 234.638C134.282 234.638 128.354 240.419 128.117 247.64H77.8893C77.6527 240.419 71.7247 234.638 64.4465 234.638C57.1683 234.638 51.2403 240.419 51.0038 247.64H35.3046V229.706L55.928 199.22H80.1381V182.631H163.08Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M163.08 247.64V248.64C163.632 248.64 164.08 248.192 164.08 247.64H163.08ZM163.08 182.631H164.08C164.08 182.079 163.632 181.631 163.08 181.631V182.631ZM155.003 247.64L154.003 247.672C154.021 248.212 154.463 248.64 155.003 248.64V247.64ZM128.117 247.64V248.64C128.657 248.64 129.099 248.212 129.117 247.672L128.117 247.64ZM77.8893 247.64L76.8898 247.672C76.9075 248.212 77.3497 248.64 77.8893 248.64V247.64ZM51.0038 247.64V248.64C51.5434 248.64 51.9856 248.212 52.0033 247.672L51.0038 247.64ZM35.3046 247.64H34.3046C34.3046 248.192 34.7523 248.64 35.3046 248.64V247.64ZM35.3046 229.706L34.4763 229.146C34.3644 229.311 34.3046 229.507 34.3046 229.706H35.3046ZM55.928 199.22V198.22C55.5961 198.22 55.2857 198.384 55.0997 198.659L55.928 199.22ZM80.1381 199.22V200.22C80.6904 200.22 81.1381 199.772 81.1381 199.22H80.1381ZM80.1381 182.631V181.631C79.5858 181.631 79.1381 182.079 79.1381 182.631H80.1381ZM164.08 247.64V182.631H162.08V247.64H164.08ZM155.003 248.64H163.08V246.64H155.003V248.64ZM141.56 235.638C148.297 235.638 153.784 240.989 154.003 247.672L156.002 247.607C155.748 239.849 149.38 233.638 141.56 233.638V235.638ZM129.117 247.672C129.336 240.989 134.823 235.638 141.56 235.638V233.638C133.741 233.638 127.372 239.849 127.118 247.607L129.117 247.672ZM77.8893 248.64H128.117V246.64H77.8893V248.64ZM64.4465 235.638C71.1834 235.638 76.6709 240.989 76.8898 247.672L78.8887 247.607C78.6346 239.849 72.2661 233.638 64.4465 233.638V235.638ZM52.0033 247.672C52.2222 240.989 57.7097 235.638 64.4465 235.638V233.638C56.627 233.638 50.2585 239.849 50.0044 247.607L52.0033 247.672ZM35.3046 248.64H51.0038V246.64H35.3046V248.64ZM34.3046 229.706V247.64H36.3046V229.706H34.3046ZM55.0997 198.659L34.4763 229.146L36.1329 230.267L56.7563 199.78L55.0997 198.659ZM80.1381 198.22H55.928V200.22H80.1381V198.22ZM79.1381 182.631V199.22H81.1381V182.631H79.1381ZM163.08 181.631H80.1381V183.631H163.08V181.631Z",
    fill: "#4F4F4F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1382 227.465H163.08V231.948H83.2936L80.1382 227.465Z",
    fill: "#B0B0B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1382 199.668V227.465H163.08",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4464 203.255L64.4464 231.948",
    stroke: "#4A4A4A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.08 247.64V248.64C163.632 248.64 164.08 248.192 164.08 247.64H163.08ZM163.08 182.631H164.08C164.08 182.079 163.632 181.631 163.08 181.631V182.631ZM155.003 247.64L154.003 247.672C154.021 248.212 154.463 248.64 155.003 248.64V247.64ZM128.117 247.64V248.64C128.657 248.64 129.099 248.212 129.117 247.672L128.117 247.64ZM77.8893 247.64L76.8898 247.672C76.9075 248.212 77.3497 248.64 77.8893 248.64V247.64ZM51.0038 247.64V248.64C51.5434 248.64 51.9856 248.212 52.0033 247.672L51.0038 247.64ZM35.3046 247.64H34.3046C34.3046 248.192 34.7523 248.64 35.3046 248.64V247.64ZM35.3046 229.706L34.4763 229.146C34.3644 229.311 34.3046 229.507 34.3046 229.706H35.3046ZM55.928 199.22V198.22C55.5961 198.22 55.2857 198.384 55.0997 198.659L55.928 199.22ZM80.1381 199.22V200.22C80.6904 200.22 81.1381 199.772 81.1381 199.22H80.1381ZM80.1381 182.631V181.631C79.5858 181.631 79.1381 182.079 79.1381 182.631H80.1381ZM164.08 247.64V182.631H162.08V247.64H164.08ZM155.003 248.64H163.08V246.64H155.003V248.64ZM141.56 235.638C148.297 235.638 153.784 240.989 154.003 247.672L156.002 247.607C155.748 239.849 149.38 233.638 141.56 233.638V235.638ZM129.117 247.672C129.336 240.989 134.823 235.638 141.56 235.638V233.638C133.741 233.638 127.372 239.849 127.118 247.607L129.117 247.672ZM77.8893 248.64H128.117V246.64H77.8893V248.64ZM64.4465 235.638C71.1834 235.638 76.6709 240.989 76.8898 247.672L78.8887 247.607C78.6346 239.849 72.2661 233.638 64.4465 233.638V235.638ZM52.0033 247.672C52.2222 240.989 57.7097 235.638 64.4465 235.638V233.638C56.627 233.638 50.2585 239.849 50.0044 247.607L52.0033 247.672ZM35.3046 248.64H51.0038V246.64H35.3046V248.64ZM34.3046 229.706V247.64H36.3046V229.706H34.3046ZM55.0997 198.659L34.4763 229.146L36.1329 230.267L56.7563 199.78L55.0997 198.659ZM80.1381 198.22H55.928V200.22H80.1381V198.22ZM79.1381 182.631V199.22H81.1381V182.631H79.1381ZM163.08 181.631H80.1381V183.631H163.08V181.631Z",
    fill: "#4A4A4A"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 286.078,
    y: 153.438,
    width: 54.617,
    height: 80.0581,
    rx: 10,
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 287.078,
    y: 154.438,
    width: 49.4199,
    height: 73.3152,
    rx: 9,
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M313.956 234.171L313.956 259.681",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 264.738,
    y: 192.467,
    width: 35.0502,
    height: 51.0304,
    rx: 10,
    fill: "#E0E0E0",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 265.738,
    y: 193.467,
    width: 31.042,
    height: 46.0513,
    rx: 9,
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M282.296 242.497L282.296 259.681",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 259.234H339M346 259.234H354.5M363.5 259.234H367.5",
    stroke: "#4A4A4A",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitation);
export default __webpack_public_path__ + "static/media/invitation.b6a56e57bc3f6c83b51e8760595b93e1.svg";
export { ForwardRef as ReactComponent };